import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, QrCodeIcon, ReceiptIcon, ArrowRightLeftIcon, CheckCircle2 } from 'lucide-react';
const steps = [{
  icon: <UsersIcon className="w-6 h-6 text-kitty-dark" data-id="element-128" data-mp="7qipvm3tws95" />,
  title: 'Create a kitty',
  description: 'Start a shared pot for a trip, night out, house share or event, and name it whatever your group calls it.'
}, {
  icon: <QrCodeIcon className="w-6 h-6 text-kitty-dark" data-id="element-129" data-mp="lk9xuq1ww42r" />,
  title: 'Invite the group',
  description: 'Share a link, code or QR, pick people from your contacts, or add someone by name for them to claim later.'
}, {
  icon: <ReceiptIcon className="w-6 h-6 text-kitty-dark" data-id="element-130" data-mp="cshv71j4pz8q" />,
  title: 'Add the spends',
  description: 'Snap the receipt to fill it in, set who paid, and choose exactly who the spend is shared with.'
}, {
  icon: <ArrowRightLeftIcon className="w-6 h-6 text-kitty-dark" data-id="element-131" data-mp="14imdmunbwc7b" />,
  title: 'See who owes who',
  description: 'KittyPot works out the fewest payments needed, person to person, with a breakdown behind every amount.'
}, {
  icon: <CheckCircle2 className="w-6 h-6 text-kitty-dark" data-id="element-132" data-mp="2rmfv0s5l4sq9" />,
  title: 'Settle up your way',
  description: 'Pay by bank transfer or cash, mark it as paid, and the person receiving it confirms when it lands.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-28 lg:py-36 bg-white" data-id="element-133" data-mp="31dak04a7u6fe">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134" data-mp="2wj6bvhp7rscq">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-135" data-mp="3abe3yw5jyv53">
          <div className="inline-flex bg-kitty-yellow-100 text-kitty-yellow-800 rounded-full px-3 py-1 text-xs font-semibold mb-4" data-id="element-136" data-mp="3ae0cay09peod">
            How it works
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-137" data-mp="3k9tm49mlqu2g">
            Group money made simple.
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto mb-3" data-id="element-138" data-mp="1pw2bb6sje45f">
            Create a shared pot, track what everyone spends, and settle up
            together when the trip is done.
          </p>
          <p className="text-sm font-semibold text-kitty-dark/50 mb-5" data-id="element-139" data-mp="3l00ekskh4cad">
            Clear costs. Fair splits. Simple settlement.
          </p>
        </div>

        <div className="relative" data-id="element-140" data-mp="3pytqigk43v8f">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0 border-t-2 border-dashed border-kitty-yellow-200 -z-10" data-id="element-141" data-mp="3tyltmdqql96e" />

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-4" data-id="element-142" data-mp="7syn3d95z7e1">
            {steps.map((step, index) => <motion.div key={step.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="relative flex flex-col items-center text-center group" data-id="element-143" data-mp="crs4hgrknijh" data-mpi={index}>
                <div className="w-24 h-24 rounded-3xl bg-kitty-yellow-50 flex items-center justify-center mb-6 group-hover:bg-kitty-yellow-100 transition-colors relative shadow-sm border border-kitty-yellow-100" data-id="element-144" data-mp="vi025jci5gsa">
                  {/* Number badge */}
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center border-4 border-white shadow-sm" data-id="element-145" data-mp="10m28eq8qffvy">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-lg font-bold text-kitty-dark mb-2" data-id="element-146" data-mp="1oc66ki35infk">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed px-2" data-id="element-147" data-mp="1en4u31vteo6c">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}